export default __webpack_public_path__ + "4ba2e77e0babb9e46b682843f7907e32.svg";